import React, { FC, ReactElement } from 'react';

import LoadingDisplay from '@nhl/nhl-react-ui/lib/LoadingDisplay';

import { useBaseAwardsQuery } from '../../../../../redux/ducks/awards';
import { Award as AwardType } from '../../../../../types/AwardTypes';
import { SubNav, TableLayout } from '../../../../components';
import { Component as Award } from '../../../award';
import AwardTombstone from '../../../award/components/awardTombstone';
import TrophySelect from '../../../award/components/trophySelect';
import { StanleyCupWinnerContainer } from '../../styles';

type Props = {
    navListView: ReactElement;
    selectedView: any;
};

const StanleyCupWinners: FC<Props> = ({ navListView, selectedView }) => {
    const { data: baseAwards = [], isFetching } = useBaseAwardsQuery({});
    const baseAward = baseAwards.find((award) => award.slug === selectedView.awardSlug) as AwardType;

    const navigation = (
        <SubNav>
            <TrophySelect trophySlug={selectedView.awardSlug} />
            {navListView}
        </SubNav>
    );

    return (
        <LoadingDisplay isLoading={isFetching}>
            <StanleyCupWinnerContainer>
                <AwardTombstone baseAward={baseAward} />
                <TableLayout header={selectedView.label} subNav={navigation} />
                <Award awardSlug={selectedView.awardSlug} showHeaders={false} />
            </StanleyCupWinnerContainer>
        </LoadingDisplay>
    );
};

export default StanleyCupWinners;
